import styles from "./part1.module.scss";
import { useEffect } from "react";
import { EffectFade, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import lottie from "lottie-web";
import dataJson1 from "../../svg/home_swiper1.json";
import dataJson2 from "../../svg/home_swiper2.json";

export default function HomePart1(props) {
  let timer = null;
  const listArr = [
    {
      title: "Free Phone Number",
      desc: "Get a free phone number for WiFi calling and unlimited texts to US and CA.",
    },
    {
      title: "Online Calls to Any Line",
      desc: "Free online call to any mobile or landline with no sim card or cell plans needed.",
    },
    {
      title: "Text with a Real Number",
      desc: "Free online SMS, texts, voice and images on a real number from an app.",
    },
  ];

  const createSvg = () => {
    window.swiper1 = lottie.loadAnimation({
      container: document.getElementsByClassName("swiperaa")[0],
      renderer: "svg",
      loop: false,
      autoplay: true,
      animationData: dataJson1,
      setDirection: 1,
    });
    window.swiper2 = lottie.loadAnimation({
      container: document.getElementsByClassName("swiperaa")[1],
      renderer: "svg",
      loop: false,
      autoplay: true,
      animationData: dataJson1,
      setDirection: 1,
    });
    window.swiper3 = lottie.loadAnimation({
      container: document.getElementsByClassName("swiperbb")[0],
      renderer: "svg",
      loop: false,
      autoplay: false,
      animationData: dataJson2,
      setDirection: 1,
    });
    window.swiper4 = lottie.loadAnimation({
      container: document.getElementsByClassName("swiperbb")[1],
      renderer: "svg",
      loop: false,
      autoplay: false,
      animationData: dataJson2,
      setDirection: 1,
    });

    timer = setTimeout(() => {
      window.swiper3.play();
      window.swiper4.play();
    }, 2500);
  };

  const slideChange = (id) => {
    if (
      !window.swiper1 &&
      !window.swiper2 &&
      !window.swiper3 &&
      !window.swiper4
    )
      return;
    if (id === 0) {
      window.swiper1.play();
      window.swiper2.play();
      window.swiper3.stop();
      window.swiper4.stop();
    } else {
      window.swiper1.stop();
      window.swiper2.stop();
      window.swiper3.play();
      window.swiper4.play();
    }
  };

  useEffect(() => {
    return () => {
      window.swiper1 = null;
      window.swiper2 = null;
      window.swiper3 = null;
      window.swiper4 = null;

      clearTimeout(timer)
    };
  }, []);

  return (
    <div className={styles.part1 + " main"}>
      <h2>Best Free Calling App for Unlimited Calls & Texts</h2>
      <div className={styles.inner + " flex-r"}>
        <div className={styles.left}>
          <Swiper
            modules={[Pagination, Autoplay, EffectFade]}
            spaceBetween={50}
            slidesPerView={1}
            autoplay={{ delay: 2000, disableOnInteraction: false }}
            loop={true}
            speed={2000}
            pagination={{ clickable: true }}
            effect="fade"
            fadeEffect={{
              crossFade: true,
            }}
            onSwiper={() => {
              // console.log("onSwiper");
              createSvg();
            }}
            onSlideChange={(e) => {
              // console.log("onSlideChange");
              slideChange(e.realIndex);
            }}
          >
            <SwiperSlide className="swiperaa"></SwiperSlide>
            <SwiperSlide className="swiperbb"></SwiperSlide>
          </Swiper>
        </div>
        <div className={styles.right}>
          <ul>
            {listArr.map((item, index) => (
              <li className={styles.list + " flex-r"} key={index}>
                <div className={styles.listLeft}>
                  <img src="/img/icon_tick.png" alt="icon tick" />
                </div>
                <div className={styles.listRight}>
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
